export default __webpack_public_path__ + "static/media/heart.67730760.svg";